<script>

    import {onMount} from "svelte";

    onMount(async () =>{
        // $flow_steps.df_branch = "exclusive";
        // if(window.location.href.includes("va.")){
        //     setTimeout(() => {
        //     gtag_event('va_mailer', 'event', 'VA Rate Table Site');
        // }, 10);

        // }
        // if(window.location.href.includes("live.")){
        //     gtag_event('general_mailer', 'event', 'Live Rate Table Site');
        // }

    });

	

</script>
Nothing here.
<style>

</style>